// This file is auto generated, run yarn icons:prepare to update
import { makeBox, MakeBoxProps } from "../../components/layout";
import { ReactComponent as Alarm } from "./assets/Alarm.svg";
import { ReactComponent as Archive } from "./assets/Archive.svg";
import { ReactComponent as ArrowDown } from "./assets/ArrowDown.svg";
import { ReactComponent as ArrowElbowDownLeft } from "./assets/ArrowElbowDownLeft.svg";
import { ReactComponent as ArrowFatUp } from "./assets/ArrowFatUp.svg";
import { ReactComponent as ArrowRight } from "./assets/ArrowRight.svg";
import { ReactComponent as ArrowsSplit } from "./assets/ArrowsSplit.svg";
import { ReactComponent as Atom } from "./assets/Atom.svg";
import { ReactComponent as Baby } from "./assets/Baby.svg";
import { ReactComponent as Barbell } from "./assets/Barbell.svg";
import { ReactComponent as Bed } from "./assets/Bed.svg";
import { ReactComponent as Bell } from "./assets/Bell.svg";
import { ReactComponent as Bird } from "./assets/Bird.svg";
import { ReactComponent as Bone } from "./assets/Bone.svg";
import { ReactComponent as Book } from "./assets/Book.svg";
import { ReactComponent as BookDuo } from "./assets/BookDuo.svg";
import { ReactComponent as BookmarksSimple } from "./assets/BookmarksSimple.svg";
import { ReactComponent as BookOpenText } from "./assets/BookOpenText.svg";
import { ReactComponent as Books } from "./assets/Books.svg";
import { ReactComponent as BooksFilled } from "./assets/BooksFilled.svg";
import { ReactComponent as Brain } from "./assets/Brain.svg";
import { ReactComponent as BriefCase } from "./assets/BriefCase.svg";
import { ReactComponent as Buildings } from "./assets/Buildings.svg";
import { ReactComponent as Calculator } from "./assets/Calculator.svg";
import { ReactComponent as CalendarBlank } from "./assets/CalendarBlank.svg";
import { ReactComponent as CalendarChecked } from "./assets/CalendarChecked.svg";
import { ReactComponent as CaretDoubleDown } from "./assets/CaretDoubleDown.svg";
import { ReactComponent as CaretDoubleUp } from "./assets/CaretDoubleUp.svg";
import { ReactComponent as CaretRight } from "./assets/CaretRight.svg";
import { ReactComponent as ChalkboardTeacher } from "./assets/ChalkboardTeacher.svg";
import { ReactComponent as ChalkStick } from "./assets/ChalkStick.svg";
import { ReactComponent as ChalkStickDocument } from "./assets/ChalkStickDocument.svg";
import { ReactComponent as Chart } from "./assets/Chart.svg";
import { ReactComponent as ChartLineUp } from "./assets/ChartLineUp.svg";
import { ReactComponent as Chat } from "./assets/Chat.svg";
import { ReactComponent as ChatCircleText } from "./assets/ChatCircleText.svg";
import { ReactComponent as ChatsCircle } from "./assets/ChatsCircle.svg";
import { ReactComponent as CheckSquare } from "./assets/CheckSquare.svg";
import { ReactComponent as ChevronDown } from "./assets/ChevronDown.svg";
import { ReactComponent as ChevronLeft } from "./assets/ChevronLeft.svg";
import { ReactComponent as ChevronRight } from "./assets/ChevronRight.svg";
import { ReactComponent as Church } from "./assets/Church.svg";
import { ReactComponent as CirclesThree } from "./assets/CirclesThree.svg";
import { ReactComponent as CircleWavyCheck } from "./assets/CircleWavyCheck.svg";
import { ReactComponent as Circuitry } from "./assets/Circuitry.svg";
import { ReactComponent as Classes } from "./assets/Classes.svg";
import { ReactComponent as Clock } from "./assets/Clock.svg";
import { ReactComponent as Coding } from "./assets/Coding.svg";
import { ReactComponent as Cog } from "./assets/Cog.svg";
import { ReactComponent as Copy } from "./assets/Copy.svg";
import { ReactComponent as Cpu } from "./assets/Cpu.svg";
import { ReactComponent as Cross } from "./assets/Cross.svg";
import { ReactComponent as Desktop } from "./assets/Desktop.svg";
import { ReactComponent as Dna } from "./assets/Dna.svg";
import { ReactComponent as DotsHorizontal } from "./assets/DotsHorizontal.svg";
import { ReactComponent as DotsVertical } from "./assets/DotsVertical.svg";
import { ReactComponent as DownloadFile } from "./assets/DownloadFile.svg";
import { ReactComponent as Edit } from "./assets/Edit.svg";
import { ReactComponent as Envelope } from "./assets/Envelope.svg";
import { ReactComponent as ExamQuestion } from "./assets/ExamQuestion.svg";
import { ReactComponent as ExclamationCircle } from "./assets/ExclamationCircle.svg";
import { ReactComponent as Export } from "./assets/Export.svg";
import { ReactComponent as Eye } from "./assets/Eye.svg";
import { ReactComponent as EyeSlashed } from "./assets/EyeSlashed.svg";
import { ReactComponent as FileAudio } from "./assets/FileAudio.svg";
import { ReactComponent as FileAudioPause } from "./assets/FileAudioPause.svg";
import { ReactComponent as FileAudioPlay } from "./assets/FileAudioPlay.svg";
import { ReactComponent as FilePdf } from "./assets/FilePdf.svg";
import { ReactComponent as Files } from "./assets/Files.svg";
import { ReactComponent as FileX } from "./assets/FileX.svg";
import { ReactComponent as FilmReel } from "./assets/FilmReel.svg";
import { ReactComponent as Filters } from "./assets/Filters.svg";
import { ReactComponent as Flask } from "./assets/Flask.svg";
import { ReactComponent as ForkKnife } from "./assets/ForkKnife.svg";
import { ReactComponent as Gauge } from "./assets/Gauge.svg";
import { ReactComponent as Gavel } from "./assets/Gavel.svg";
import { ReactComponent as GearFine } from "./assets/GearFine.svg";
import { ReactComponent as Globe } from "./assets/Globe.svg";
import { ReactComponent as GlobeHemisphereWest } from "./assets/GlobeHemisphereWest.svg";
import { ReactComponent as GoStudentLoader } from "./assets/GoStudentLoader.svg";
import { ReactComponent as GraduationCap } from "./assets/GraduationCap.svg";
import { ReactComponent as Grains } from "./assets/Grains.svg";
import { ReactComponent as Group } from "./assets/Group.svg";
import { ReactComponent as HamburgerMenu } from "./assets/HamburgerMenu.svg";
import { ReactComponent as Hammer } from "./assets/Hammer.svg";
import { ReactComponent as HandHeart } from "./assets/HandHeart.svg";
import { ReactComponent as Heart } from "./assets/Heart.svg";
import { ReactComponent as Help } from "./assets/Help.svg";
import { ReactComponent as House } from "./assets/House.svg";
import { ReactComponent as IdentificationCard } from "./assets/IdentificationCard.svg";
import { ReactComponent as Image } from "./assets/Image.svg";
import { ReactComponent as ImageMulti } from "./assets/ImageMulti.svg";
import { ReactComponent as Infinity } from "./assets/Infinity.svg";
import { ReactComponent as Info } from "./assets/Info.svg";
import { ReactComponent as KeyReturn } from "./assets/KeyReturn.svg";
import { ReactComponent as LaurelStar } from "./assets/LaurelStar.svg";
import { ReactComponent as Leave } from "./assets/Leave.svg";
import { ReactComponent as Lifebuoy } from "./assets/Lifebuoy.svg";
import { ReactComponent as LightBulb } from "./assets/LightBulb.svg";
import { ReactComponent as LightBulbBigFilled } from "./assets/LightBulbBigFilled.svg";
import { ReactComponent as Lightning } from "./assets/Lightning.svg";
import { ReactComponent as LightningOutline } from "./assets/LightningOutline.svg";
import { ReactComponent as Link } from "./assets/Link.svg";
import { ReactComponent as ListMagnifyingGlass } from "./assets/ListMagnifyingGlass.svg";
import { ReactComponent as Lock } from "./assets/Lock.svg";
import { ReactComponent as LockOpen } from "./assets/LockOpen.svg";
import { ReactComponent as MagicWand } from "./assets/MagicWand.svg";
import { ReactComponent as Magnet } from "./assets/Magnet.svg";
import { ReactComponent as MaskHappy } from "./assets/MaskHappy.svg";
import { ReactComponent as MathOperations } from "./assets/MathOperations.svg";
import { ReactComponent as Medal } from "./assets/Medal.svg";
import { ReactComponent as Megaphone } from "./assets/Megaphone.svg";
import { ReactComponent as Microphone } from "./assets/Microphone.svg";
import { ReactComponent as MicrophoneOutlined } from "./assets/MicrophoneOutlined.svg";
import { ReactComponent as MicrophoneSlash } from "./assets/MicrophoneSlash.svg";
import { ReactComponent as Minus } from "./assets/Minus.svg";
import { ReactComponent as Money } from "./assets/Money.svg";
import { ReactComponent as Moon } from "./assets/Moon.svg";
import { ReactComponent as MoonStars } from "./assets/MoonStars.svg";
import { ReactComponent as More } from "./assets/More.svg";
import { ReactComponent as Mountains } from "./assets/Mountains.svg";
import { ReactComponent as Muscle } from "./assets/Muscle.svg";
import { ReactComponent as MusicNotes } from "./assets/MusicNotes.svg";
import { ReactComponent as NonCalculator } from "./assets/NonCalculator.svg";
import { ReactComponent as NotePencil } from "./assets/NotePencil.svg";
import { ReactComponent as Palette } from "./assets/Palette.svg";
import { ReactComponent as Pause } from "./assets/Pause.svg";
import { ReactComponent as PeoplePair } from "./assets/PeoplePair.svg";
import { ReactComponent as Person } from "./assets/Person.svg";
import { ReactComponent as PersonsArmsSpread } from "./assets/PersonsArmsSpread.svg";
import { ReactComponent as Pin } from "./assets/Pin.svg";
import { ReactComponent as Planet } from "./assets/Planet.svg";
import { ReactComponent as Plant } from "./assets/Plant.svg";
import { ReactComponent as Play } from "./assets/Play.svg";
import { ReactComponent as PlayCircleFilled } from "./assets/PlayCircleFilled.svg";
import { ReactComponent as Plus } from "./assets/Plus.svg";
import { ReactComponent as PlusCircle } from "./assets/PlusCircle.svg";
import { ReactComponent as QuestionBadge } from "./assets/QuestionBadge.svg";
import { ReactComponent as QuestionBadgeOutlined } from "./assets/QuestionBadgeOutlined.svg";
import { ReactComponent as ReadMore } from "./assets/ReadMore.svg";
import { ReactComponent as Reassign } from "./assets/Reassign.svg";
import { ReactComponent as Report } from "./assets/Report.svg";
import { ReactComponent as Robot } from "./assets/Robot.svg";
import { ReactComponent as RobotDuo } from "./assets/RobotDuo.svg";
import { ReactComponent as Rocket } from "./assets/Rocket.svg";
import { ReactComponent as Rows } from "./assets/Rows.svg";
import { ReactComponent as Ruler } from "./assets/Ruler.svg";
import { ReactComponent as Scales } from "./assets/Scales.svg";
import { ReactComponent as School } from "./assets/School.svg";
import { ReactComponent as Scroll } from "./assets/Scroll.svg";
import { ReactComponent as Search } from "./assets/Search.svg";
import { ReactComponent as Send } from "./assets/Send.svg";
import { ReactComponent as Seneca } from "./assets/Seneca.svg";
import { ReactComponent as SenecaLoader } from "./assets/SenecaLoader.svg";
import { ReactComponent as Share } from "./assets/Share.svg";
import { ReactComponent as Shower } from "./assets/Shower.svg";
import { ReactComponent as Shuffle } from "./assets/Shuffle.svg";
import { ReactComponent as Skip } from "./assets/Skip.svg";
import { ReactComponent as SmileyXEyes } from "./assets/SmileyXEyes.svg";
import { ReactComponent as SmileyXEyesFilled } from "./assets/SmileyXEyesFilled.svg";
import { ReactComponent as SoundWave } from "./assets/SoundWave.svg";
import { ReactComponent as SpeakerHigh } from "./assets/SpeakerHigh.svg";
import { ReactComponent as SpeakerSlash } from "./assets/SpeakerSlash.svg";
import { ReactComponent as Spinner } from "./assets/Spinner.svg";
import { ReactComponent as Squares } from "./assets/Squares.svg";
import { ReactComponent as Star } from "./assets/Star.svg";
import { ReactComponent as StarFilled } from "./assets/StarFilled.svg";
import { ReactComponent as StopCircle } from "./assets/StopCircle.svg";
import { ReactComponent as Stopwatch } from "./assets/Stopwatch.svg";
import { ReactComponent as Strategy } from "./assets/Strategy.svg";
import { ReactComponent as Student } from "./assets/Student.svg";
import { ReactComponent as StudentDuo } from "./assets/StudentDuo.svg";
import { ReactComponent as Sun } from "./assets/Sun.svg";
import { ReactComponent as SunHorizon } from "./assets/SunHorizon.svg";
import { ReactComponent as Synced } from "./assets/Synced.svg";
import { ReactComponent as Target } from "./assets/Target.svg";
import { ReactComponent as Television } from "./assets/Television.svg";
import { ReactComponent as Tick } from "./assets/Tick.svg";
import { ReactComponent as TickCircle } from "./assets/TickCircle.svg";
import { ReactComponent as TickCircleFilled } from "./assets/TickCircleFilled.svg";
import { ReactComponent as Transfer } from "./assets/Transfer.svg";
import { ReactComponent as Translate } from "./assets/Translate.svg";
import { ReactComponent as Trash } from "./assets/Trash.svg";
import { ReactComponent as Tree } from "./assets/Tree.svg";
import { ReactComponent as Trend } from "./assets/Trend.svg";
import { ReactComponent as Trophy } from "./assets/Trophy.svg";
import { ReactComponent as Warning } from "./assets/Warning.svg";
import { ReactComponent as WhatsApp } from "./assets/WhatsApp.svg";
import { ReactComponent as WordFill } from "./assets/WordFill.svg";
import { ReactComponent as XCircle } from "./assets/XCircle.svg";

export const iconNameMap: {
  [key in IconName]: (props: MakeBoxProps) => JSX.Element;
} = {
  alarm: makeBox(Alarm),
  archive: makeBox(Archive),
  arrowDown: makeBox(ArrowDown),
  arrowElbowDownLeft: makeBox(ArrowElbowDownLeft),
  arrowFatUp: makeBox(ArrowFatUp),
  arrowRight: makeBox(ArrowRight),
  arrowsSplit: makeBox(ArrowsSplit),
  atom: makeBox(Atom),
  baby: makeBox(Baby),
  barbell: makeBox(Barbell),
  bed: makeBox(Bed),
  bell: makeBox(Bell),
  bird: makeBox(Bird),
  bone: makeBox(Bone),
  book: makeBox(Book),
  bookDuo: makeBox(BookDuo),
  bookOpenText: makeBox(BookOpenText),
  bookmarksSimple: makeBox(BookmarksSimple),
  books: makeBox(Books),
  booksFilled: makeBox(BooksFilled),
  brain: makeBox(Brain),
  briefCase: makeBox(BriefCase),
  buildings: makeBox(Buildings),
  calculator: makeBox(Calculator),
  calendarBlank: makeBox(CalendarBlank),
  calendarChecked: makeBox(CalendarChecked),
  caretDoubleDown: makeBox(CaretDoubleDown),
  caretDoubleUp: makeBox(CaretDoubleUp),
  caretRight: makeBox(CaretRight),
  chalkStick: makeBox(ChalkStick),
  chalkStickDocument: makeBox(ChalkStickDocument),
  chalkboardTeacher: makeBox(ChalkboardTeacher),
  chart: makeBox(Chart),
  chartLineUp: makeBox(ChartLineUp),
  chat: makeBox(Chat),
  chatCircleText: makeBox(ChatCircleText),
  chatsCircle: makeBox(ChatsCircle),
  checkSquare: makeBox(CheckSquare),
  chevronDown: makeBox(ChevronDown),
  chevronLeft: makeBox(ChevronLeft),
  chevronRight: makeBox(ChevronRight),
  church: makeBox(Church),
  circleWavyCheck: makeBox(CircleWavyCheck),
  circlesThree: makeBox(CirclesThree),
  circuitry: makeBox(Circuitry),
  classes: makeBox(Classes),
  clock: makeBox(Clock),
  coding: makeBox(Coding),
  cog: makeBox(Cog),
  copy: makeBox(Copy),
  cpu: makeBox(Cpu),
  cross: makeBox(Cross),
  desktop: makeBox(Desktop),
  dna: makeBox(Dna),
  dotsHorizontal: makeBox(DotsHorizontal),
  dotsVertical: makeBox(DotsVertical),
  downloadFile: makeBox(DownloadFile),
  edit: makeBox(Edit),
  envelope: makeBox(Envelope),
  examQuestion: makeBox(ExamQuestion),
  exclamationCircle: makeBox(ExclamationCircle),
  export: makeBox(Export),
  eye: makeBox(Eye),
  eyeSlashed: makeBox(EyeSlashed),
  fileAudio: makeBox(FileAudio),
  fileAudioPause: makeBox(FileAudioPause),
  fileAudioPlay: makeBox(FileAudioPlay),
  filePdf: makeBox(FilePdf),
  fileX: makeBox(FileX),
  files: makeBox(Files),
  filmReel: makeBox(FilmReel),
  filters: makeBox(Filters),
  flask: makeBox(Flask),
  forkKnife: makeBox(ForkKnife),
  gauge: makeBox(Gauge),
  gavel: makeBox(Gavel),
  gearFine: makeBox(GearFine),
  globe: makeBox(Globe),
  globeHemisphereWest: makeBox(GlobeHemisphereWest),
  goStudentLoader: makeBox(GoStudentLoader),
  graduationCap: makeBox(GraduationCap),
  grains: makeBox(Grains),
  group: makeBox(Group),
  hamburgerMenu: makeBox(HamburgerMenu),
  hammer: makeBox(Hammer),
  handHeart: makeBox(HandHeart),
  heart: makeBox(Heart),
  help: makeBox(Help),
  house: makeBox(House),
  identificationCard: makeBox(IdentificationCard),
  image: makeBox(Image),
  imageMulti: makeBox(ImageMulti),
  infinity: makeBox(Infinity),
  info: makeBox(Info),
  keyReturn: makeBox(KeyReturn),
  laurelStar: makeBox(LaurelStar),
  leave: makeBox(Leave),
  lifebuoy: makeBox(Lifebuoy),
  lightBulb: makeBox(LightBulb),
  lightBulbBigFilled: makeBox(LightBulbBigFilled),
  lightning: makeBox(Lightning),
  lightningOutline: makeBox(LightningOutline),
  link: makeBox(Link),
  listMagnifyingGlass: makeBox(ListMagnifyingGlass),
  lock: makeBox(Lock),
  lockOpen: makeBox(LockOpen),
  magicWand: makeBox(MagicWand),
  magnet: makeBox(Magnet),
  maskHappy: makeBox(MaskHappy),
  mathOperations: makeBox(MathOperations),
  medal: makeBox(Medal),
  megaphone: makeBox(Megaphone),
  microphone: makeBox(Microphone),
  microphoneOutlined: makeBox(MicrophoneOutlined),
  microphoneSlash: makeBox(MicrophoneSlash),
  minus: makeBox(Minus),
  money: makeBox(Money),
  moon: makeBox(Moon),
  moonStars: makeBox(MoonStars),
  more: makeBox(More),
  mountains: makeBox(Mountains),
  muscle: makeBox(Muscle),
  musicNotes: makeBox(MusicNotes),
  nonCalculator: makeBox(NonCalculator),
  notePencil: makeBox(NotePencil),
  palette: makeBox(Palette),
  pause: makeBox(Pause),
  peoplePair: makeBox(PeoplePair),
  person: makeBox(Person),
  personsArmsSpread: makeBox(PersonsArmsSpread),
  pin: makeBox(Pin),
  planet: makeBox(Planet),
  plant: makeBox(Plant),
  play: makeBox(Play),
  playCircleFilled: makeBox(PlayCircleFilled),
  plus: makeBox(Plus),
  plusCircle: makeBox(PlusCircle),
  questionBadge: makeBox(QuestionBadge),
  questionBadgeOutlined: makeBox(QuestionBadgeOutlined),
  readMore: makeBox(ReadMore),
  reassign: makeBox(Reassign),
  report: makeBox(Report),
  robot: makeBox(Robot),
  robotDuo: makeBox(RobotDuo),
  rocket: makeBox(Rocket),
  rows: makeBox(Rows),
  ruler: makeBox(Ruler),
  scales: makeBox(Scales),
  school: makeBox(School),
  scroll: makeBox(Scroll),
  search: makeBox(Search),
  send: makeBox(Send),
  seneca: makeBox(Seneca),
  senecaLoader: makeBox(SenecaLoader),
  share: makeBox(Share),
  shower: makeBox(Shower),
  shuffle: makeBox(Shuffle),
  skip: makeBox(Skip),
  smileyXEyes: makeBox(SmileyXEyes),
  smileyXEyesFilled: makeBox(SmileyXEyesFilled),
  soundWave: makeBox(SoundWave),
  speakerHigh: makeBox(SpeakerHigh),
  speakerSlash: makeBox(SpeakerSlash),
  spinner: makeBox(Spinner),
  squares: makeBox(Squares),
  star: makeBox(Star),
  starFilled: makeBox(StarFilled),
  stopCircle: makeBox(StopCircle),
  stopwatch: makeBox(Stopwatch),
  strategy: makeBox(Strategy),
  student: makeBox(Student),
  studentDuo: makeBox(StudentDuo),
  sun: makeBox(Sun),
  sunHorizon: makeBox(SunHorizon),
  synced: makeBox(Synced),
  target: makeBox(Target),
  television: makeBox(Television),
  tick: makeBox(Tick),
  tickCircle: makeBox(TickCircle),
  tickCircleFilled: makeBox(TickCircleFilled),
  transfer: makeBox(Transfer),
  translate: makeBox(Translate),
  trash: makeBox(Trash),
  tree: makeBox(Tree),
  trend: makeBox(Trend),
  trophy: makeBox(Trophy),
  warning: makeBox(Warning),
  whatsApp: makeBox(WhatsApp),
  wordFill: makeBox(WordFill),
  xCircle: makeBox(XCircle)
};

export type IconName =
  | "alarm"
  | "archive"
  | "arrowDown"
  | "arrowElbowDownLeft"
  | "arrowFatUp"
  | "arrowRight"
  | "arrowsSplit"
  | "atom"
  | "baby"
  | "barbell"
  | "bed"
  | "bell"
  | "bird"
  | "bone"
  | "book"
  | "bookDuo"
  | "bookOpenText"
  | "bookmarksSimple"
  | "books"
  | "booksFilled"
  | "brain"
  | "briefCase"
  | "buildings"
  | "calculator"
  | "calendarBlank"
  | "calendarChecked"
  | "caretDoubleDown"
  | "caretDoubleUp"
  | "caretRight"
  | "chalkStick"
  | "chalkStickDocument"
  | "chalkboardTeacher"
  | "chart"
  | "chartLineUp"
  | "chat"
  | "chatCircleText"
  | "chatsCircle"
  | "checkSquare"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "church"
  | "circleWavyCheck"
  | "circlesThree"
  | "circuitry"
  | "classes"
  | "clock"
  | "coding"
  | "cog"
  | "copy"
  | "cpu"
  | "cross"
  | "desktop"
  | "dna"
  | "dotsHorizontal"
  | "dotsVertical"
  | "downloadFile"
  | "edit"
  | "envelope"
  | "examQuestion"
  | "exclamationCircle"
  | "export"
  | "eye"
  | "eyeSlashed"
  | "fileAudio"
  | "fileAudioPause"
  | "fileAudioPlay"
  | "filePdf"
  | "fileX"
  | "files"
  | "filmReel"
  | "filters"
  | "flask"
  | "forkKnife"
  | "gauge"
  | "gavel"
  | "gearFine"
  | "globe"
  | "globeHemisphereWest"
  | "goStudentLoader"
  | "graduationCap"
  | "grains"
  | "group"
  | "hamburgerMenu"
  | "hammer"
  | "handHeart"
  | "heart"
  | "help"
  | "house"
  | "identificationCard"
  | "image"
  | "imageMulti"
  | "infinity"
  | "info"
  | "keyReturn"
  | "laurelStar"
  | "leave"
  | "lifebuoy"
  | "lightBulb"
  | "lightBulbBigFilled"
  | "lightning"
  | "lightningOutline"
  | "link"
  | "listMagnifyingGlass"
  | "lock"
  | "lockOpen"
  | "magicWand"
  | "magnet"
  | "maskHappy"
  | "mathOperations"
  | "medal"
  | "megaphone"
  | "microphone"
  | "microphoneOutlined"
  | "microphoneSlash"
  | "minus"
  | "money"
  | "moon"
  | "moonStars"
  | "more"
  | "mountains"
  | "muscle"
  | "musicNotes"
  | "nonCalculator"
  | "notePencil"
  | "palette"
  | "pause"
  | "peoplePair"
  | "person"
  | "personsArmsSpread"
  | "pin"
  | "planet"
  | "plant"
  | "play"
  | "playCircleFilled"
  | "plus"
  | "plusCircle"
  | "questionBadge"
  | "questionBadgeOutlined"
  | "readMore"
  | "reassign"
  | "report"
  | "robot"
  | "robotDuo"
  | "rocket"
  | "rows"
  | "ruler"
  | "scales"
  | "school"
  | "scroll"
  | "search"
  | "send"
  | "seneca"
  | "senecaLoader"
  | "share"
  | "shower"
  | "shuffle"
  | "skip"
  | "smileyXEyes"
  | "smileyXEyesFilled"
  | "soundWave"
  | "speakerHigh"
  | "speakerSlash"
  | "spinner"
  | "squares"
  | "star"
  | "starFilled"
  | "stopCircle"
  | "stopwatch"
  | "strategy"
  | "student"
  | "studentDuo"
  | "sun"
  | "sunHorizon"
  | "synced"
  | "target"
  | "television"
  | "tick"
  | "tickCircle"
  | "tickCircleFilled"
  | "transfer"
  | "translate"
  | "trash"
  | "tree"
  | "trend"
  | "trophy"
  | "warning"
  | "whatsApp"
  | "wordFill"
  | "xCircle";
